module.exports = __webpack_public_path__ + "img/time.7af26a26.svg";